@if (editFeature.featureType) {
  <div class="editFeatures">
    <div class="panel px-0" [style.height.px]="panelHeight">
      <div class="container py-2 px-0">
        <div class="pt-1">
          <div class="d-block title">
            <button class="btn btn-link float-left w-100 text-start p-0 d-flex" title="Close Edit Features"
              (click)="clearFeatureType(editFeature.featureLayerId)">
              <div class="chevron-wrapper"><i class="fas fa-chevron-left fa-sm"></i></div>
              <div class="d-inline-block mt-2 title-text">{{editFeature.featureType}}</div>
            </button>
          </div>
        </div>
        <div class="form-group px-3 mt-2 d-flex show-active-wrapper" [formGroup]="showActiveForm">
          <input type="checkbox" formControlName="showActiveLayers" value="false" id="showActiveLayers" (change)="toggleActiveLayer($event)"> <label for="showActiveLayers">Show Map Layer(s)</label>
        </div>
        <div class="form-group px-3 mt-2">
          @if (isDesktop) {
            <p><i class="fal fa-mouse-pointer"></i> <span class="ml-2">Select a feature on the map to edit</span></p>
          }
          @if (!isDesktop) {
            <button type="button" class="btn btn-primary mb-2" (click)="onEditFeature()">
              <i class="fas fa-arrow-left rotate-45"></i>
            Select a feature on the map to edit</button>
          }
          <button type="button" class="btn btn-primary" (click)="addNewFeature(editFeature.shape)"
            [disabled]="mapState.editFeaturesPermission && !mapState.editFeaturesPermission.add"><i
          class="far fa-plus"></i> Add New Feature</button>
          @if (mapState.editFeaturesPermission && !mapState.editFeaturesPermission.add) {
            <div class="mt-2">Geometry
              editing has been disabled on this
              layer. Please talk
            to your GIS Admin if you believe this is an error.</div>
          }
        </div>
      </div>
    </div>
    <!-- multiple results -->
    @if (mapState.surroundingFeatureList) {
      <div class="panel px-0" [style.height.px]="panelHeight">
        <div class="container py-2 px-0">
          <div class="pt-1">
            <div class="d-block title">
              <button class="btn btn-link float-left w-100 text-start p-0 d-flex" title="Close Edit Features"
                (click)="clearFeatureType(editFeature.featureLayerId)">
                <div class="chevron-wrapper"><i class="fas fa-chevron-left fa-sm"></i></div>
                <div class="d-inline-block mt-2 title-text">{{editFeature.featureType}}</div>
              </button>
            </div>
          </div>
          <div class="form-group px-3 mt-2">
            <!-- <h3 class="mb-2">Multiple Results</h3> -->
            <button class="btn btn-link float-left w-100 text-start p-0 d-flex btn-multi-results mb-2"
              (click)="clearMultiResults()">
              <div class="chevron-wrapper mr-2"><i class="fas fa-chevron-left fa-sm"></i></div>Multiple Results
            </button>
            @for (feature of mapState.surroundingFeatureList; track feature) {
              <label class="px-2" (mouseenter)="mouseEnter(feature.objectId, feature.featureId, feature.name)"
                (mouseleave)="mouseLeave()" for="sFeaturesDetails"
                (click)="setFeatureDetails(feature.objectId, feature.url, feature.writeUrl, feature.allowInsp, feature.featureId, feature.assetId)">
                <div class="idFeature d-flex justify-content-between">
                  <div class="feature-text">
                    <span class="w-100">{{feature.name}}</span>
                    @if (feature.keyAttribute.length > 0) {
                      <span class="keyAttr">{{feature.keyAttribute}}</span>
                    }
                  </div>
                  <div class="icon">
                    <i class="far fa-chevron-right mt-1 float-right"></i>
                  </div>
                </div>
              </label>
            }
          </div>
        </div>
      </div>
    }
    <!-- single / new feature -->
    @if (mapState.selectedFeature && mapState.selectedFeature.length > 0 || newFeature) {
      <div class="panel px-0" [style.height.px]="panelHeight"
        [class.mobile-hidden]="editingFeature">
        <div class="container py-2 px-0">
          <div class="pt-1">
            <div class="d-block title">
              <button class="btn btn-link float-left w-100 text-start p-0 d-flex" title="Close Edit Features"
                (click)="clearFeatureValues()">
                <div class="chevron-wrapper"><i class="fas fa-chevron-left fa-sm"></i></div>
                <div class="d-inline-block mt-2 title-text">{{editFeature.featureType}}</div>
              </button>
            </div>
          </div>
          <div class="form-group px-3 mt-2 edit-feature-form">
            <form class="needs-validation" (ngSubmit)="onSubmit()">
              <div class="featureDetails" [formGroup]="featureForm">
                <div class="d-flex justify-content-between">
                  <!-- <button *ngIf="newFeature" type="button" class="btn btn-outline-secondary" title="delete new feature added"
                  (click)="deleteNewFeature()"><i class="fal fa-trash-alt"></i></button> -->
                  @if (!newFeature) {
                    <strong>{{editAssetId}}</strong>
                  }
                  @if (newFeature) {
                    <strong>{{newAssetId}}</strong>
                  }
                  @if (readOnly) {
                    <button type="button" class="btn btn-link" (click)="editForm()">Edit</button>
                  }
                  @if (!readOnly) {
                    <button type="button" class="btn btn-link" (click)="cancelForm(true)">Cancel</button>
                  }
                </div>
                @if (mapState.editFeaturesPermission.snapLayers && mapState.editFeaturesPermission.snapLayers.length > 0) {
                  <div class="row mx-0"
                    >
                    <div class="col px-0"><label for="snap" class="bg-transparent border-0 shadow-none">Snap to
                    layer(s):</label></div>
                    <div class="col pl-0"><input id="snap" type="checkbox" [checked]="mapState.snapToLayers"
                      (click)="toggleSnap()" class="snap-checkbox">
                    </div>
                  </div>
                }
                @for (m of formCtrls; track m) {
                  <div
                    [class.hidden]="newFeature && (m.ctrlName.toLowerCase().indexOf('created') > -1 || m.ctrlName.toLowerCase().indexOf('edited') > -1)">
                    @if (newFeature) {
                      <div>
                        @if (m.ctrlName.toLowerCase().indexOf(maxAsset.name) > -1) {
                          <div class="key-pair">
                            <input type="hidden" [formControlName]="m.ctrlName" class="form-control">
                          </div>
                        }
                      </div>
                    }
                    @if (m.ctrlName.toLowerCase().indexOf(maxAsset.name) === -1) {
                      <div class="key-pair">
                        @if (m.inputType !== 'hidden') {
                          <span class="label">{{m.label}}</span>
                          }@if (m.required && !featureForm.get(m.ctrlName).disabled && m.inputType !== 'hidden') {
                          <span
                          class="text-danger">*</span>
                        }
                        @if (m.inputType === 'text') {
                          <div>
                            <input type=" text" [formControlName]="m.ctrlName" class="form-control" [required]="m.required">
                          </div>
                        }
                        @if (m.inputType === 'select') {
                          <div>
                            <ng-select [ngModel]="featureForm.get(m.ctrlName).value" [formControlName]="m.ctrlName"
                              [required]="m.required">
                              @for (opt of m.domain; track opt) {
                                <ng-option [value]="opt.code">
                                  {{ opt.name }}
                                </ng-option>
                              }
                            </ng-select>
                          </div>
                        }
                        @if (m.inputType === 'hidden') {
                          <div>
                            <input type="hidden" [formControlName]="m.ctrlName" class="form-control">
                          </div>
                        }
                      </div>
                    }
                    @if (m.ctrlName.toLowerCase().indexOf(maxAsset.name) > -1) {
                      <div class="key-pair">
                        <input type="text" [formControlName]="m.ctrlName" class="form-control" type="hidden">
                      </div>
                    }
                  </div>
                }
                <div class="d-flex justify-content-between mb-2">
                  <div><span class="text-danger">*</span> Required</div>
                  <button type="submit" [disabled]="(featureForm.invalid && !featureForm.disabled) || featureForm.disabled"
                    class="btn btn-primary">
                    @if (newFeature) {
                      <span>Save</span>
                    }
                    @if (!newFeature) {
                      <span>Update</span>
                    }
                  </button>
                </div>
              </div>
            </form>
            @if (!newFeature && mapState.editFeaturesPermission.delete) {
              <div class="d-flex justify-content-center">
                <button type="button" class="btn btn-link text-danger" (click)="deleteFeature()">Delete Feature</button>
              </div>
            }
          </div>
        </div>
      </div>
    }
  </div>
}

@if (showSpinner) {
  <div class="showSpin d-flex justify-content-center" [style.height.px]="panelHeight">
    <i class="fas fa-3x fa-spinner fa-spin"></i>
  </div>
}
<ng-template #deleteConfirm let-modal>

  <div class="modal-header">
    <h5>Delete Feature</h5>
  </div>

  <div class="modal-body">
    Are you sure you want to delete this feature? This action cannot be undone.
  </div>

  <div class="modal-footer d-flex justify-content-center">

    <button type="button" class="btn" (click)="dismiss()"><i class="fas fa-times"></i>Cancel</button>
    <button type="button" class="btn btn-danger" (click)="confirmDelete()"><i class="fas fa-check"></i>Delete</button>
  </div>

</ng-template>